// DesktopNav.js - Horizontal desktop navigation with Admin dropdown
import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi';
import NavLink from './NavLink';
import { getVisibleGroups } from '../../config/navigation';

const DesktopNav = ({ isAuthenticated, adminLevel, onLogout }) => {
  const groups = getVisibleGroups(isAuthenticated, adminLevel);
  const flatItems = groups.filter(g => g.id !== 'admin').flatMap(g => g.items);
  const adminGroup = groups.find(g => g.id === 'admin');

  const [adminOpen, setAdminOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setAdminOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close when navigating
  useEffect(() => {
    setAdminOpen(false);
  }, [location.pathname]);

  const isAdminPath = adminGroup?.items.some(item => item.path === location.pathname);

  return (
    <nav className="hidden md:flex items-center space-x-1 lg:space-x-2">
      {flatItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          icon={item.icon}
          label={item.label}
          showIcon={false}
          className="text-[clamp(0.7rem,1.5vw,0.875rem)] px-2 py-1"
        />
      ))}

      {adminGroup && adminGroup.items.length > 0 && (
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setAdminOpen(open => !open)}
            className={`flex items-center gap-1 px-2 py-1 rounded-md text-[clamp(0.7rem,1.5vw,0.875rem)] transition-colors ${
              isAdminPath
                ? 'bg-blue-600 text-white'
                : 'text-gray-300 hover:text-white hover:bg-gray-700'
            }`}
          >
            Admin
            <FiChevronDown className={`w-3.5 h-3.5 transition-transform ${adminOpen ? 'rotate-180' : ''}`} />
          </button>

          {adminOpen && (
            <div className="absolute right-0 z-50 mt-2 w-52 bg-gray-800 border border-gray-700 rounded-lg shadow-xl py-1">
              {adminGroup.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  icon={item.icon}
                  label={item.label}
                  showIcon={true}
                  onClick={() => setAdminOpen(false)}
                  className="text-sm mx-1"
                />
              ))}
            </div>
          )}
        </div>
      )}

      {isAuthenticated && (
        <button
          onClick={onLogout}
          className="text-gray-300 hover:text-white hover:bg-gray-700 px-2 py-1 rounded-md text-[clamp(0.7rem,1.5vw,0.875rem)] transition-colors"
        >
          Logout
        </button>
      )}
    </nav>
  );
};

export default DesktopNav;
